import { useEffect, useState } from 'react';

function Title() {
  const text = 'Selamat Datang di SIMANAP | RSUD H. ABDUL MANAP KOTA JAMBI | ';
  const [title, setTitle] = useState(text);

  useEffect(() => {
    const interval = setInterval(() => {
      setTitle((prev) => prev.slice(1) + prev.charAt(0));
    }, 300);

    document.title = title;

    return () => {
      clearInterval(interval);
    };
  }, [title]);

  return null;
}

export default Title;
